<!--内部系统内容管理-->
<template>
  <sys-content-mange :actionType="ACTION_TYPE.system"/>
</template>

<script>
import SysContentMange from '@/epp/sysContentMange/SysContentMange.vue'
import { ACTION_TYPE } from '@/epp/sysContentMange/util/sysContentMangeUtil'

export default {
  name: 'SysContentMangeIndex',
  computed: {

  },
  components: { SysContentMange },
  data () {
    return {
      ACTION_TYPE
    }
  },
  methods: {},
}
</script>

<style lang="less" scoped>
</style>
